import React, { useContext } from 'react';
import './gdpr.styles.scss';
import { GlobalDispatchContext } from '../../context/globalContextProvider';
import cross from "../../assets/images/cross.png";

const Gdpr = () => {
    const dispatch = useContext(GlobalDispatchContext);

    const close = () => {
        dispatch({
            type: 'SET_GDPR_OPEN',
            gdprIsOpen: false
        })
    }

    const openPolicy = () => {
        window.scrollTo(0, 0)
        dispatch({
            type: 'SET_POLICY_OPEN',
            policyIsOpen: true
        })
    }

    return (
        <div className="gdpr-container">
            <div className="close">
                <img src={cross} alt="close" onClick={close}/>

            </div>

            <h1>Your Privacy</h1>

            <div className="policy-body">
                <p>We do not collect cookies on this site. 
                    For more information about your privacy on this site please
                    see our <span className="policy-link" onClick={openPolicy}>privacy policy</span>
                </p>

                <button onClick={close}>Accept</button>

            </div>

            
        </div>
    )
}

export default Gdpr;